import { Operation } from 'fast-json-patch';
import { colorPaletteOutline, cut, flame } from 'ionicons/icons';
import { ReactElement } from 'react';
import { Scratchpad } from '../api/graphql/generated';
import { ScratchpadHistoryCompareVersionsProps } from '../components/scratchpad/scratchpad-history-compare';
import { BeaconCuttingPage } from './application/beacon/cutting/beacon-cutting.page';
import { BeaconCuttingData } from './application/beacon/cutting/model/beacon-cutting-data';
import { BeaconPaintingPage } from './application/beacon/painting/beacon-painting.page';
import { BeaconPaintingData } from './application/beacon/painting/model/beacon-painting-data';
import { BeaconWeldingPage } from './application/beacon/welding/beacon-welding.page';
import { BeaconWeldingData } from './application/beacon/welding/model/beacon-welding-data';
import { FlowDiff } from './application/shared/component/flow-diff/flow-diff';
import { diffFlowAppData } from './application/shared/util/flow-diff.util';

interface SlugMapping<P = undefined> {
  [slug: string]: P;
}

export interface ScratchpadPageProps {
  teamId: string;
  machineId: string;
  scratchpad?: Scratchpad;
}

export type ScratchpadAppDataDiffFn = (options: {
  oldAppData: Scratchpad['appData'];
  newAppData: Scratchpad['appData'];
}) => Array<Operation>;

const ScratchpadPageMappings: SlugMapping<
  (props: ScratchpadPageProps) => ReactElement
> = {
  [BeaconWeldingData.APP_SLUG]: BeaconWeldingPage,
  [BeaconCuttingData.APP_SLUG]: BeaconCuttingPage,
  [BeaconPaintingData.APP_SLUG]: BeaconPaintingPage,
};

const ScratchpadAppIcon: SlugMapping<string> = {
  [BeaconWeldingData.APP_SLUG]: flame,
  [BeaconCuttingData.APP_SLUG]: cut,
  [BeaconPaintingData.APP_SLUG]: colorPaletteOutline,
};

const ScratchpadHistoryDiffSlugMappings: SlugMapping<
  (props: ScratchpadHistoryCompareVersionsProps) => ReactElement
> = {
  [BeaconWeldingData.APP_SLUG]: FlowDiff,
  [BeaconCuttingData.APP_SLUG]: FlowDiff,
  [BeaconPaintingData.APP_SLUG]: FlowDiff,
};

const ScratchpadAppDataDiffFnSlugMappings: SlugMapping<ScratchpadAppDataDiffFn> =
  {
    [BeaconWeldingData.APP_SLUG]: diffFlowAppData,
    [BeaconCuttingData.APP_SLUG]: diffFlowAppData,
    [BeaconPaintingData.APP_SLUG]: diffFlowAppData,
  };

export {
  ScratchpadAppIcon,
  ScratchpadAppDataDiffFnSlugMappings,
  ScratchpadHistoryDiffSlugMappings,
  ScratchpadPageMappings,
};
